<script>
import { mapGetters } from 'vuex'
export default {
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
	},
	computed: {
		client() {
			return this.clientById(Number(this.$route.params.id))
		},
		...mapGetters({
			clientById: 'arceClients/getById'
		})
	}
}
</script>
<template>
	<div class="d-flex flex-wrap px-1 py-1 s-single">
		<div class="col-12 p-0">
			<div class="d-flex flex-wrap py-1">
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						<div class="s-panel__header bg-light p-3">
							<div class="d-flex align-items-center">
								<div class="s-element__icon">
									<img src="@/assets/simulator/account_120.png" alt="">
								</div>
								<div>
									<p class="m-0">{{client.type}}</p>
									<h3 class="title">{{client.name}} {{client.code}}</h3>
								</div>
								<div class="ml-auto d-flex">
									<button class="s-btn s-btn--outline s-btn--primary">
										<SvgIcon name="add"/>
										Seguir
									</button>
									<div class="ml-3 s-btn-group">
										<button class="s-btn s-btn--outline s-btn--primary">
											ARCE
										</button>
										<button class="s-btn s-btn--outline s-btn-primary">
											Modificar
										</button>
										<button class="s-btn s-btn--outline s-btn-primary">
											Cambiar propietario
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="s-panel__body p-3">
							<div class="d-flex">
								<div class="col-1">
									<p class="m-0">Razon social</p>
								</div>
								<div class="col-1">
									<p class="m-0">RFC</p>
								</div>
								<div v-if="client.parent" class="col-2">
									<p class="m-0">Número de Grupo Económico</p>
									<p>{{client.parent.code}}</p>
								</div>
								<div v-else class="col-2">
									<p class="m-0">Número de Cliente</p>
									<p>{{client.code}}</p>
								</div>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-8 col-xl-9 p-0">
			<div class="d-flex flex-wrap">
				<div class="col-12 px-2 py-2">
					<div class="s-panel h-100">
						<div class="s-panel__body p-3 position-relative h-100">
							<div class="s-nav-tab">
								<button class="s-nav-tab__item s-nav-tab__item--active">
									Relacionado
								</button>
								<button class="s-nav-tab__item">
									Detalle
								</button>
							</div>
							<div class="py-2">
								<div class="s-collapse__header" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
									<div class="d-flex">
										<h1 class="title"><svg-icon name="chevrondown" /> <span>Información del cliente</span></h1>
									</div>
								</div>
								<div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
									<div class="d-flex flex-wrap">
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Nombre comerecial del cliente</p>
												<p class="font-weight-bold m-0">{{client.name}}</p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Sector</p>
												<p class="m-0"></p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div v-if="client.parent" class="border-bottom h-100 py-2">
												<p class="m-0">Número de Grupo Económico</p>
												<p class="m-0">{{client.parent.code}}</p>
											</div>
											<div v-else class="border-bottom h-100 py-2">
												<p class="m-0">Número de Client</p>
												<p class="m-0">{{client.code}}</p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Actividad</p>
												<p class="m-0 py-2"></p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Saneamineto del grupo</p>
												<p class="m-0 py-2"></p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Giro</p>
												<p class="m-0 py-2"></p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Última Actualización del Grupo Económico</p>
												<p class="m-0 py-2">
													
												</p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Rangos de ventas M.N.</p>
												<p class="m-0 py-2"></p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">GGA</p>
												<p class="m-0">
													<a href="#">JUAN SEBASTIAN SOTO</a>
												</p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Grupo controlado por Sponsor Financiero</p>
												<p class="m-0">
													No
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="py-2">
								<div class="s-collapse__header" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
									<div class="d-flex">
										<h1 class="title"><svg-icon name="chevrondown" /> <span>Información del sistema</span></h1>
									</div>
								</div>
								<div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo">
									<div class="d-flex flex-wrap">
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Propietario del cliente</p>
												<p class="m-0">
													<a href="#">JUAN SEBASTIAN SOTO</a>
												</p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Última modificación por</p>
												<p class="m-0">
													<a href="#">JUAN SEBASTIAN SOTO</a> 6/23/2020 9:43 AM
												</p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="border-bottom h-100 py-2">
												<p class="m-0">Grupo al que pertenece</p>
												<p class="m-0 py-2">
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-4 col-xl-3 p-0">
			<div class="d-flex flex-wrap">
				<div class="col-12 px-2 py-2">
					<div class="s-collapse__header py-3 border" data-toggle="collapse" data-target="#aside1" aria-expanded="true" aria-controls="aside1">
						<div class="d-flex">
							<p class="font-weight-bold m-0">
								<span class="s-element__icon s-element__icon--24 s-element__icon--purple">
									<img src="@/assets/simulator/account_120.png" alt="">
								</span>
								<span>Análisis de Riesgo (0)</span>
							</p>
						</div>
					</div>
				</div>
				<div class="col-12 px-2 py-2">
					<div class="s-collapse__header py-3 border" data-toggle="collapse" data-target="#aside1" aria-expanded="true" aria-controls="aside1">
						<div class="d-flex">
							<p class="font-weight-bold m-0">
								<span class="s-element__icon s-element__icon--24 s-element__icon--purple">
									<img src="@/assets/simulator/account_120.png" alt="">
								</span>
								<span>Análisis de Riesgo (Cuenta) (0)</span>
							</p>
						</div>
					</div>
				</div>
				<div class="col-12 px-2 py-2">
					<div class="s-collapse__header py-3 border" data-toggle="collapse" data-target="#aside1" aria-expanded="true" aria-controls="aside1">
						<div class="d-flex">
							<p class="font-weight-bold m-0">
								<span class="s-element__icon s-element__icon--24 s-element__icon--purple">
									<img src="@/assets/simulator/account_120.png" alt="">
								</span>
								<span>Clientes (Cuenta) (0)</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>	
		
	</div>
</template>